import { useState, useEffect } from 'react';
import { styleKeyVarMap, getSwanStylesheetUrl, SwanPathTypeEnum, SWAN_BASE_URL_MAP } from '@vp/swan';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const useSwanCustomStyles = () => {
  const { logCustomAttributesNR } = useNRLogging();
  const [isLoading, setIsLoading] = useState(true);
  const [loadedStyles, setLoadedStyles] = useState([]);
  const [error, setError] = useState(null);
  const requiredStyles = ["core", "alertBox", "button", "fileTile", "icon", "selectionSet", "spinner", "statusMessage"];
  useEffect(() => {
    const loadSwanStyles = async () => {
      try {
        const style = getComputedStyle(document.documentElement);
        const stylesToLoad = requiredStyles.filter((key) => {
          const cssVar = styleKeyVarMap[key];
          if (!cssVar) return false;
          return style.getPropertyValue(cssVar) !== "1";
        });
        if (stylesToLoad.length === 0) {
          setIsLoading(false);
          return;
        }
        const stylePromises = stylesToLoad.map((style2) => {
          return new Promise((resolve, reject) => {
            const url = getSwanStylesheetUrl(style2, SwanPathTypeEnum.hashed, SWAN_BASE_URL_MAP.vistaprint.com);
            if (url) {
              console.warn(`ca-chatbot: loading Swan stylesheet for ${style2}`);
              const link = document.createElement("link");
              link.rel = "stylesheet";
              link.type = "text/css";
              link.href = url;
              link.onload = () => resolve(style2);
              link.onerror = () => reject(new Error(`Failed to load styles for ${style2}`));
              document.head.appendChild(link);
            }
          });
        });
        const loaded = await Promise.all(stylePromises);
        setLoadedStyles(loaded);
        setIsLoading(false);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Unknown error loading styles"));
        logCustomAttributesNR("ca-chatbot-init-error", { logLevel: "error", message: err.message, errorType: "stylesError" });
        setIsLoading(false);
      }
    };
    loadSwanStyles();
  }, []);
  return { isLoading, loadedStyles, error };
};

export { useSwanCustomStyles as default, useSwanCustomStyles };
//# sourceMappingURL=src-hooks-custom-hooks-useSwanCustomStyles.js.map
